import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/bullet/ai-pro.png";
import type { Product } from "../../types";
import { physicalSecurityBullet } from "../product-list-groups/physicalSecurityBullet";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const aiPro: Product = {
  id: "aiPro",
  productTitle: "AI Pro",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-ai-pro`,
  ],
  storePathParts: {
    productSlug: "uvc-ai-pro",
    category: UniFiChildCategorySlug.CamerasBullet,
  },
  sku: "UVC-AI-Pro",
  description: "aiPro.description",
  image: { src: image, width: 200, height: 140 },
  productListGroup: physicalSecurityBullet,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value:
          'Without mount:\nØ86 x 112.6 mm (Ø3.4 x 4.4")\nWith mount:\nØ86 x 175.3 mm (Ø3.4 x 6.9")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.8" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "aiPro.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "translation",
        value: "aiPro.nightVision",
      },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "string", value: "3x" },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.twoWayAudio" },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP65" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
